module.exports = __webpack_public_path__ + "/img/724d57f4535300ef9a0bf520e526855d.png";